import { useTheme } from 'styled-components';

import type { IconProps } from '~types/icon';

export default function Hamberger({ width = 21, height = 17, color, ...props }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 21 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M0.769531 1.94869C0.769531 1.21119 1.40792 0.615356 2.1981 0.615356H19.341C20.1311 0.615356 20.7695 1.21119 20.7695 1.94869C20.7695 2.68619 20.1311 3.28202 19.341 3.28202H2.1981C1.40792 3.28202 0.769531 2.68619 0.769531 1.94869ZM0.769531 8.61536C0.769531 7.87786 1.40792 7.28202 2.1981 7.28202H19.341C20.1311 7.28202 20.7695 7.87786 20.7695 8.61536C20.7695 9.35286 20.1311 9.94869 19.341 9.94869H2.1981C1.40792 9.94869 0.769531 9.35286 0.769531 8.61536ZM20.7695 15.282C20.7695 16.0195 20.1311 16.6154 19.341 16.6154H2.1981C1.40792 16.6154 0.769531 16.0195 0.769531 15.282C0.769531 14.5445 1.40792 13.9487 2.1981 13.9487H19.341C20.1311 13.9487 20.7695 14.5445 20.7695 15.282Z'
        fill={color || theme.colors.gray900}
      />
    </svg>
  );
}
